import Vue from 'vue';

const success = (context, response) => {
  context.billing = response.data.billing;
  context.closeModal('#change-card-modal');
  context.loading = false;
  toastr.success(context.$t('account.settings.credit_card.card_created_success'));
};

const failed = (context, error) => {
  context.loading = false;
  context.showToasterError(error);
};

export default (context, data) => {
  return Vue.$http.post('user-billing/create', data)
        .then(response => {
          success(context, response)
        }).catch(error => {
          failed(context, error)
        });
}



// WEBPACK FOOTER //
// ./src/app/services/user-billing/storeCard.js